import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <h2>SSD Linehaul Pending Geofence</h2>
  <h3>Description</h3>
  <p>This disruption occurs when an outbound SSD truck has left the NACF but has not broken the destinations site's Geofence.</p>
  <h3>SOP</h3>
  <ul>
    <li><b>At Risk (Yellow):</b> No action needed. This is a proactive injection status notification.</li>
    <li><b>Critical (Red):</b> No action needed. This is a proactive injection status notification.</li>
    <li><b>Late (Orange):</b> No action needed. This is a proactive injection status notification. CO is monitoring and will cap as needed.</li>
  </ul>
  <h2>Staffing Recommendation</h2>
  <ul>
    <li>For every 300 packages in the trailer, 1 additional associate is needed to support a 2 hour SLA.</li>
    <li>For trailers arriving after CET, add 1 associate per 200 packages.</li>
  </ul>
</div>`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_LINEHAUL_PENDING_GEOFENCE.jsx